/**
 * scheduleTrimNote.ts
 * G2-2 (scheduling audit #2) — shared advisory copy for the execution-feedback
 * schedule trims. When a test is Approved (or removed) or a WO is Completed,
 * the backend end-trims the remaining schedule days and returns these counts;
 * every surface phrases them identically through this helper.
 */

export interface ScheduleTrimCounts {
  /** Strictly-future bookings soft-deleted. */
  bookingsReleased: number;
  /** Bookings spanning today whose end was trimmed to today. */
  bookingsTrimmed: number;
  /** Staffing rows released with the future bookings. */
  assignmentsReleased: number;
}

/** True when the trim actually freed anything (drives whether to mention it). */
export function trimFreedAnything(t: ScheduleTrimCounts | undefined | null): t is ScheduleTrimCounts {
  return !!t && (t.bookingsReleased > 0 || t.bookingsTrimmed > 0 || t.assignmentsReleased > 0);
}

/** "2 future booking(s) released, 1 booking now ends today, 3 staffing week(s) freed" */
export function formatTrimNote(t: ScheduleTrimCounts): string {
  const bits: string[] = [];
  if (t.bookingsReleased > 0) bits.push(`${t.bookingsReleased} future booking(s) released`);
  if (t.bookingsTrimmed > 0) bits.push(`${t.bookingsTrimmed} booking(s) now end today`);
  if (t.assignmentsReleased > 0) bits.push(`${t.assignmentsReleased} staffing week(s) freed`);
  return bits.join(', ');
}
